module.exports = __webpack_public_path__ + "img/backhand_index_pointing_left.35893489.gif";